module.exports = __webpack_public_path__ + "img/product13.d9c7965b.png";